import getBrowserResolution from '../util/getBrowserResolution';
import scrollTop from '../util/scrollTop';

export default {
  init() {
    // JavaScript to be fired on all pages
    scroll(0,0);
    var footerForm = document.getElementById('footer-insurance-quotes');
    var headerHeight = document.querySelector('.brand').offsetHeight;
    var footer = document.getElementsByClassName('content-info')[0];
    var init = footerForm.offsetTop - scrollTop();
    footerForm.className = 'footer_insurance_quotes docked';
    init = init - footerForm.offsetTop;
    footerForm.className = 'footer_insurance_quotes';
    var docked = false;

    window.onresize = function() { scrollDiv(scrollTop()) };
    window.onscroll = function() { scrollDiv(scrollTop()) };

    function scrollDiv(scrollTop) {

      if ( !docked && scrollTop < init && scrollTop > headerHeight ) {
          footerForm.className = 'footer_insurance_quotes docked';
          docked = true;
      } else if ( docked && scrollTop >= init || scrollTop < headerHeight ) {
          footerForm.className = footerForm.className.replace('footer_insurance_quotes docked', 'footer_insurance_quotes');
          docked = false;
      }
    }
  },
  finalize() {

    var viewportwidth;
    var viewportheight;
    getBrowserResolution(viewportwidth, viewportheight);

    jQuery.fx.speeds._default = 600;

    $('form.insurance-form').submit(function() {

      getBrowserResolution(viewportwidth, viewportheight);
      var current_state = $(this).find('select.insurance-type').find('option:selected').val();
      if (current_state == 0) {
        $(this).find('select.insurance-type').addClass('red-border');
        return false;
      }

      $(this).find('select.insurance-type').removeClass('red-border');
      var url = $(this).attr('action');
      var data = $(this).serialize();

      var output = '<iframe src="'+ url +'?'+ data + '" width="'+ viewportwidth * 0.75 + '" height="' + viewportheight * 0.70 + '" id="ifr_quotes" name="ifr_quotes" frameborder="0" scrolling="auto" allowtransparency="true" style="display: none; text-align:center; margin: 0 auto;" ></iframe>';

      $('#modalFrame').find('.modal-content').html(output);

      $( 'iframe#ifr_quotes' ).load( function() {
        $(this).fadeIn('def');
      });

      $('#modalFrame').modal();

      return false;
    });

    $('select.insurance-type').change(function() {
      $('select.insurance-type').removeClass('red-border')
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js